import { PATIENT_SERVICES_BASE_URL } from '@src/constants';
import { GetPatientTypeDocument } from '@src/lib/__generated/enterprise-api-sdk';
import { usePatientTypeStore } from '@src/store/modules/patientType.store';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { useClient } from 'urql';

export function usePatientType() {
	const client = useClient();
	const { push } = useRouter();
	const { patientType, setPatientType } = usePatientTypeStore();
	const [loading, setLoading] = useState(false);

	const getPatientType = useCallback(async () => {
		const result = await client.query(GetPatientTypeDocument, {}).toPromise();
		const patientType = result.data?.me?.patientType || '';
		return { data: patientType as string, error: result.error };
	}, [client]);

	useEffect(() => {
		(async () => {
			const needsPatientType = !patientType;

			if (needsPatientType) {
				setLoading(true);

				try {
					const promises: Promise<void>[] = [];

					promises.push(
						getPatientType().then(({ data }) => {
							setPatientType(data);
						})
					);

					await Promise.all(promises);
				} catch {
					push(`/${PATIENT_SERVICES_BASE_URL}/global-error/`);
				} finally {
					setLoading(false);
				}
			}
		})();
	}, [patientType, getPatientType, setPatientType]);

	return { patientType, loading, setPatientType };
}
